export default __webpack_public_path__ + "static/media/5.4e441542.jpeg";